import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

interface CancelEventInput {
  eventId: number;
  notifyGuests: boolean;
  emailNotification: boolean;
  slackNotification: boolean;
  slackMessage: string | null;
}

interface CancelEventResponse {
  cancelEvent: {
    ok: boolean;
    event: {
      id: number;
    };
  };
}

const CANCEL_EVENT_MUTATION = gql`
  mutation CancelEvent($input: CancelEventInput!) {
    cancelEvent(input: $input) {
      ok
      event {
        id
      }
    }
  }
`;

type UnpublishEventResponse = {
  unpublishEvent: {
    ok: boolean;
  };
};

const UNPUBLISH_EVENT_MUTATION = gql`
  mutation UnpublishEvent($eventId: Int!) {
    unpublishEvent(eventId: $eventId) {
      ok
    }
  }
`;

const publishedEventApi = {
  cancel: async (input: CancelEventInput): Promise<CancelEventResponse> => {
    return gqlClient.request<CancelEventResponse>(CANCEL_EVENT_MUTATION, { input });
  },
  unpublish: async (eventId: number): Promise<UnpublishEventResponse['unpublishEvent']> => {
    return gqlClient
      .request<UnpublishEventResponse>(UNPUBLISH_EVENT_MUTATION, { eventId })
      .then((res) => res.unpublishEvent);
  }
};

export { publishedEventApi, type CancelEventInput };
